import React, { useState } from 'react';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter signup
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Top section with logo, newsletter, and navigation */}
        <div className="flex flex-col md:flex-row justify-between mb-12">
          {/* Left side - Logo, copyright, and newsletter */}
          <div className="mb-8 md:mb-0">
            <div className="mb-4">
              <img 
                src="/logos/white simplified logo.svg" 
                alt="Relatable Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm mb-6">
              © {new Date().getFullYear()} • RELATABLE • by RogerTen, LLC
            </p>
            
            {/* Newsletter section */}
            <div className="mb-6 max-w-sm">
              <p className="text-gray-400 text-sm mb-3">
                Join our newsletter to stay up to date on features and releases.
              </p>
              <script src="https://f.convertkit.com/ckjs/ck.5.js"></script>
      <form
        action="https://app.kit.com/forms/8412732/subscriptions"
        className="seva-form formkit-form"
        method="post"
        data-sv-form="8412732"
        data-uid="44551c6365"
        data-format="inline"
        data-version="5"
        data-options='{"settings":{"after_subscribe":{"action":"message","success_message":"🤘 BOOM! Best decision EVER.","redirect_url":""},"analytics":{"google":null,"fathom":null,"facebook":null,"segment":null,"pinterest":null,"sparkloop":null,"googletagmanager":null},"modal":{"trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"powered_by":{"show":false,"url":"https://kit.com/features/forms?utm_campaign=poweredby&utm_content=form&utm_medium=referral&utm_source=dynamic"},"recaptcha":{"enabled":false},"return_visitor":{"action":"hide","custom_content":""},"slide_in":{"display_in":"bottom_right","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"sticky_bar":{"display_in":"top","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15}},"version":"5"}'
        style={{ maxWidth: 700, width: "100%" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div data-style="clean">
          <ul className="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul>
          <div data-element="fields" data-stacked="false" className="seva-fields formkit-fields flex flex-row gap-2">
            <div className="formkit-field flex-1">
              <input
                className="formkit-input w-full px-4 py-3 rounded-md border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                name="email_address"
                aria-label="Email Address"
                placeholder="Email Address"
                required
                type="email"
                style={{
                  background: "#fff",
                  fontSize: 15,
                  fontWeight: 400,
                  lineHeight: 1.4,
                  margin: 0,
                }}
              />
            </div>
            <button
              data-element="submit"
              className="formkit-submit bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md px-6 py-3 transition-colors duration-200 shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
              type="submit"
              style={{
                marginBottom: 0,
                position: "relative",
                overflow: "hidden",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              <div className="formkit-spinner" style={{ display: "none" }}>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <span>Subscribe</span>
            </button>
          </div>
        </div>
      </form>
              <p className="text-gray-400 text-xs">
                By subscribing you agree to with our <a href="/privacy" className="underline hover:text-white transition-colors duration-200">Privacy Policy</a> and <a href="/terms" className="underline hover:text-white transition-colors duration-200">Terms of Service</a> and provide consent to receive updates from our company.
              </p>
            </div>
          </div>

          {/* Right side - Navigation columns */}
          <div className="flex space-x-12">
            <div>
              <h3 className="font-sans text-lg font-semibold text-white mb-4">Info</h3>
              <ul className="space-y-2">
                <li><a href="/" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Home</a></li>
                <li><a href="https://www.relatable.one/signup" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Sign Up</a></li>
                <li><a href="https://relatable.helpscoutdocs.com/" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Knowledge Base</a></li>
                <li><a href="https://newsletter.bemorerelatable.com" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Newsletter</a></li>
                <li><a href="https://relatable.getrewardful.com/" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Affiliates</a></li>
                <li><a href="/privacy" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Privacy Policy</a></li>
                <li><a href="/terms" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200">Terms of Service</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-sans text-lg font-semibold text-white mb-4">Follow us</h3>
              <ul className="space-y-2">
                <li>
                  <a href="https://www.instagram.com/bemorerelatable" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://youtube.com/@zviband" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                    YouTube
                  </a>
                </li>
                <li>
                  <a href="https://linkedin.com/in/zviband" className="font-sans text-sm text-gray-400 hover:text-white transition-colors duration-200 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Made with love line */}
        <div className="text-center pt-8">
          <p className="font-sans text-xs text-gray-500">
            Made with love, matcha, and hot sauce in 🦀 Maryland and 🇵🇱 Poland. Just remember, cilantro is disgusting.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 